import { Filter } from "../types/data";

export const LOGO =
  "https://whatwatch-files.s3.eu-west-2.amazonaws.com/whatwatch-logo.svg";

export const API_KEY = "44f48e7b28d4b0278ee574993973d95a";

export const baseUrlImage = "https://image.tmdb.org/t/p/original";

export const baseYouTube = "https://www.youtube.com/watch?v=";

export const baseUrlPlatform = "https://api.whatwatch.tv/";

export const firebaseConfig = {
  apiKey: "AIzaSyBHoF6hoWyKo3MxBRxXmyYVVLEtBrUALa4",
  authDomain: "whatwatch-af479.firebaseapp.com",
  projectId: "whatwatch-af479",
  storageBucket: "whatwatch-af479.appspot.com",
  messagingSenderId: "485151355487",
  appId: "1:485151355487:web:ab3e340f8e7d498f0aa1ea",
  measurementId: "G-ZPV05P30XJ",
};

export const FILTER_MOVIE = (api: string, filter: Filter, page?: number) => {
  let url =
    "https://api.themoviedb.org/3/discover/movie?api_key=" +
    api +
    "&language=it-IT&include_adult=false";
  if (filter.genres) {
    const genres = filter.genres.toString().replaceAll(",", "|");
    url += "&with_genres=" + genres;
  }
  if (filter.startDate && filter.endDate) {
    url +=
      "&release_date.gte=" +
      filter.startDate +
      "&release_date.lte=" +
      filter.endDate;
  }
  if (filter.providers) {
    const providers = filter.providers.toString().replaceAll(",", "|");
    url += "&with_watch_providers=" + providers + "&watch_region=IT";
  }
  if (page) {
    url += "&page=" + page;
  }
  return url;
};

export const FILTER_SHOWS = (api: string, filter: Filter, page?: number) => {
  let url =
    "https://api.themoviedb.org/3/discover/tv?api_key=" +
    api +
    "&language=it-IT&include_adult=false";
  if (filter.genres) {
    const genres = filter.genres.toString().replaceAll(",", "|");
    url += "&with_genres=" + genres;
  }
  if (filter.startDate && filter.endDate) {
    url +=
      "&air_date.gte=" + filter.startDate + "&air_date.lte=" + filter.endDate;
  }
  if (filter.providers) {
    const providers = filter.providers.toString().replaceAll(",", "|");
    url += "&with_watch_providers=" + providers + "&watch_region=IT";
  }
  if (page) {
    url += "&page=" + page;
  }
  return url;
};

export const ANONYM_SEARCH_DATA = () => {
  return `${baseUrlPlatform}stats/anonym_search_data`;
};
